import TipoPersona from "./TipoPersona";

export class Identificacion{
    constructor(){
        this.Codigo = "";
        this.TipoPersona = new TipoPersona();
    }

    Codigo: string;
    TipoPersona: TipoPersona;
}
export default Identificacion;